export default function chunk(arr, size) {
  if (Array.isArray(arr)) {
    const newArr = [];
    for (let i = 0; i < Math.ceil(arr.length / size); i++) {
      newArr[i] = arr.slice(i * size, i * size + size);
    }
    return newArr;
  }
}
